export const APP_LANGUAGE = 'app_language';
export const ACCESS_TOKEN = 'access_token';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js